module.exports = __webpack_public_path__ + "static/3-ce47ff415120e8430e51a572f23fd594.jpg";